import { prepareImageUpload } from './api.js';

// Photos on a journal entry: the tank journal's notes, a resident's
// notes, and the note written when a resident leaves the tank. The note
// is saved first, then each photo goes up in its own request, canvas-first
// like every other upload (an iPhone must ship a small JPEG, not raw HEIC).

export const NOTE_PHOTO_MAX = 6;
export const NOTE_PHOTO_ACCEPT = 'image/*,.heic,.heif';

export async function uploadImageTo(url, file) {
  const { body, mime } = await prepareImageUpload(file);
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': mime },
    body,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: `HTTP ${res.status}` }));
    throw new Error(err.error || 'Upload failed');
  }
  return res.json();
}

// Uploads every photo to the same url and returns how many failed, so one
// bad file does not lose the others. `errors`, when given, collects why, so
// the keeper hears "that is a RAW photo" and not only "it failed".
export async function uploadNotePhotos(url, files, errors) {
  let failed = 0;
  for (const f of files) {
    try {
      await uploadImageTo(url, f);
    } catch (e) {
      failed++;
      if (errors && e?.message) errors.push(e.message);
    }
  }
  return failed;
}

export function photosFailedMessage(failed, total, reason = '') {
  if (!failed) return '';
  const base =
    failed === total
      ? `The note is saved, but the photo${total === 1 ? '' : 's'} could not be uploaded.`
      : `The note is saved, but ${failed} of ${total} photos could not be uploaded.`;
  return reason ? `${base} ${reason}` : base;
}
